(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".collection-tab");
  const productsWrapper = document.getElementById("collectionProductsWrapper");
  const descBox = document.getElementById("collectionDescription");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const handle = tab.dataset.handle;
      const url = `/collections/${handle}?view=carousel-products`;
      const description = tab.dataset.description || "";
     // descBox.textContent = description;
      descBox.innerHTML = description;

      // Delete old content, add loading
      productsWrapper.innerHTML = `
        <div class="collection-carousel-products active" data-handle="${handle}">
          <div class="loading-text">Loading products...</div>
        </div>
      `;

      // Load HTML to view
      fetch(url)
        .then(res => res.text())
        .then(html => {
          const content = document.createElement("div");
          content.innerHTML = html;

          const productsEl = productsWrapper.querySelector(".collection-carousel-products");
          const newContent = content.querySelector(".flickity-carousel") || content.querySelector(".collection-carousel-products");
          productsEl.innerHTML = "";

          if (newContent) {
            productsEl.appendChild(newContent);
            
           // Fix wishlist icon call , it need init 
            if (window.shopEnhancer?.initWishlistIcons) {
            window.shopEnhancer.initWishlistIcons(productsEl);
           }
            //load icon cart
             if (window.shopEnhancer?.initQuickAddIcons) {
            window.shopEnhancer.initQuickAddIcons(productsEl);
           }


            // ✅ Re-initialize Flickity after adding to DOM
            if (newContent.classList.contains("flickity-carousel")) {
              new Flickity(newContent, {
                groupCells: true,
                contain: true,
                pageDots: false,
                prevNextButtons: true
              });
            }
          } else {
            productsEl.innerHTML = "<p class='loading-text'>Unable to load product.</p>";
          }
        });
    });
  });

  //Scroll left/right tab button
  const navContainer = document.querySelector(".collection-carousel-nav");
  document.querySelector(".scroll-left").addEventListener("click", () => {
    navContainer.scrollBy({ left: -200, behavior: "smooth" });
  });
  document.querySelector(".scroll-right").addEventListener("click", () => {
    navContainer.scrollBy({ left: 200, behavior: "smooth" });
  });

  //Auto click first tab
  document.querySelector(".collection-tab.active")?.click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', () => {
  window.shopEnhancer.observeAndInit('product-recommendations');
});

/*
  document.addEventListener('product-recommendations:loaded', (event) => {
  const section = event?.target;
  if (section) {
    console.log('✅ product-recommendations loaded');
    reInitIcons(section);
  }
});
//Use MutationObserver to ensure DOM changes are always caught
  let rebindTimeout;
const observer = new MutationObserver(() => {
  clearTimeout(rebindTimeout);
  rebindTimeout = setTimeout(() => {
    const section = document.querySelector('product-recommendations');
    if (section) {
      console.log('🔁 DOM changed → rebind icons');
      reInitIcons(section);
    }
  }, 300); // run after DOM is calm for 300ms
});

observer.observe(document.body, { childList: true, subtree: true });
  
function reInitIcons(scope = document) {
  window.shopEnhancer.initQuickAddIcons(scope);
  window.shopEnhancer.initWishlistIcons(scope);
  window.shopEnhancer.updateWishlistCount?.();
  window.shopEnhancer.updateCartCount?.();
}
*/

  } catch(e) { console.error(e); }
})();
})();
